import { render, staticRenderFns } from "./index.vue?vue&type=template&id=684f97b0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684f97b0')) {
      api.createRecord('684f97b0', component.options)
    } else {
      api.reload('684f97b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=684f97b0&", function () {
      api.rerender('684f97b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/index.vue"
export default component.exports